module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-10.2b5b71bc.png";